var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7776 31.0821H14.7613V21.4074L9.07031 17.1391V29.3748C9.07031 30.3195 9.83576 31.0821 10.7776 31.0821Z",
    fill: "#080808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4199 31.0821H32.4036C33.3484 31.0821 34.111 30.3167 34.111 29.3748V17.1391L28.4199 21.4074",
    fill: "#080808"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4199 14.0092V21.4075L34.111 17.1392V14.8628C34.111 12.7514 31.7008 11.5478 30.0134 12.814",
    fill: "#080808"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7617 21.4074V14.009L21.591 19.131L28.4202 14.009V21.4074L21.591 26.5293",
    fill: "#080808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07031 14.8628V17.1392L14.7613 21.4075V14.0092L13.1679 12.814C11.4776 11.5478 9.07031 12.7514 9.07031 14.8628Z",
    fill: "#080808"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.476145ff61f7de650847e8e3aaf1b4a9.svg";
export { ForwardRef as ReactComponent };